import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { collecionFormValidation } from '../../utils/videoFormValidationUtils';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
//import USER_PROFILE from "../../utils/userProfile";

function CollectionStep6(props) {
  const {
    getValues,
    setValue,
    setCollectionResponse,
    collectionResponse,
    formValidation,
  } = props;
  const [showContainer] = useState(props.activeStep);
  const [, setVisibility] = useState('');
  const [selectedVisibilityLabel, setSelectedVisibilityLabel] = useState(null);
  const [auth] = useOutletContext();
  const [, setUserProfile] = useState();
  const [isIntegraDescription, setIsIntegraDescription] = useState(false);
  const [isShortDescription, setIsShortDescription] = useState(false);
  const [isFullDescription, setIsFullDescription] = useState(false);
  const [isComments, setIsComments] = useState(false);

  const maxLengthSeeMore = 50;
  const integraDescription = collectionResponse?.integraDescription || '';
  console.log(JSON.stringify())

  useEffect(() => {
    setUserProfile(auth.getIdToken().payload['custom:user_profile']);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCollectionResponse(getValues());
    setVisibility(collectionResponse?.visibility);
    setValue('visibility', collectionResponse?.visibility);

    for (let item of visibilities) {
      if (collectionResponse?.visibility === item.name) {
        setSelectedVisibilityLabel(item.value);
        setValue('visibility', item.name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeStep, showContainer]);

  const visibilities = [
    {
      name: 'INTERNAL_USERS',
      value: 'Somente para usuários internos (para validação prévia - preview)',
    },
    { name: 'AUTHENTICATED_USERS', value: 'Somente para usuários logados' },
    { name: 'EVERYONE', value: 'Todos usuários (Logados e não-logados)' },
  ];

  const showAllText = val => {
    if (val === 'integraDescription') {
      setIsIntegraDescription(!isIntegraDescription);
      return isIntegraDescription;
    }
    if (val === 'shortDescription') {
      setIsShortDescription(!isShortDescription);
      return isShortDescription;
    }
    if (val === 'fullDescription') {
      setIsFullDescription(!isFullDescription);
      return isFullDescription;
    }
    if (val === 'comments') {
      setIsComments(!isComments);
      return isComments;
    }
    return false;
  };
  useEffect(() => {
    setUserProfile(auth.getIdToken().payload['custom:user_profile']);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className={'step-container'} id="collection-step-six">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div
            className="video_label-title"
            style={{ marginTop: 40, marginBottom: 7 }}>
            Resumo da publicação:
          </div>
        </Grid>

        <Grid item xs={12}>
          <ul className="steps_resumo">
            <li>
              Título:{' '}
              <strong>{collectionResponse?.title || 'Não informado'} </strong>
            </li>
            <li>
              Status:
              {collectionResponse?.status === 'PUBLISHED' && (
                <strong> Publicado</strong>
              )}
              {collectionResponse?.status === 'DRAFT' && (
                <strong> Rascunho</strong>
              )}
              {collectionResponse?.status === 'ARCHIVED' && (
                <strong> Arquivado</strong>
              )}
              {collectionResponse?.status === 'FAILED' && (
                <strong> Erro de transcodificação</strong>
              )}
              {collectionResponse?.status === 'EXPIRED' && (
                <strong> EXPIRADO </strong>
              )}
            </li>
            <li>
              Classificação:{' '}
              <strong>{collectionResponse?.ageRating || 'Não informado'}</strong>
            </li>
            <li>
              Visibilidade:{' '}
              {
                <strong>
                  {selectedVisibilityLabel !== '' &&
                  selectedVisibilityLabel !== null &&
                  selectedVisibilityLabel !== undefined
                    ? selectedVisibilityLabel
                    : collectionResponse?.visibility}
                </strong>
              }
            </li>
            <li>
              Com quem:{' '}
              {collectionResponse?.personalities?.length > 0
                ? collectionResponse?.personalities.map((person, index) => (
                    <strong key={index}>
                      {' '}
                      {person.label || person?.name}{' '}
                      {index < collectionResponse?.personalities.length - 1
                        ? '/'
                        : ''}
                    </strong>
                  ))
                : 'Não informado'}
            </li>
            <li>
              Canal(is):{' '}
              {collectionResponse?.channels?.length > 0
                ? collectionResponse?.channels.map((channel, index) => (
                    <strong key={index}>
                      {' '}
                      {channel.label || channel?.name}{' '}
                      {index < collectionResponse?.channels.length - 1
                        ? '/'
                        : ''}
                    </strong>
                  ))
                : 'Não informado'}
            </li>

           {/*
<li>
  Áudio:{' '}
  <strong>
    {collectionResponse?.languageId || 'Não informado'}
  </strong>
</li>
*/}

{/*
<li>
  Contratos:{' '}
  {collectionResponse?.relatedFiles?.length > 0
    ? collectionResponse?.relatedFiles.map((file, index) => (
        <strong key={index}>
          {' '}
          {file.name}{' '}
          {index < collectionResponse?.relatedFiles.length - 1
            ? '/'
            : ''}
        </strong>
      ))
    : 'Não informado'}
</li>
*/}

{/*
<li>
  Arquivos relacionados:{' '}
  <strong>
    {collectionResponse?.relatedFiles?.length > 0
      ? collectionResponse?.relatedFiles.map((file, index) => (
          <strong key={index}>
            {file.url}{' '}
            {index < collectionResponse?.relatedFiles.length - 1
              ? '/'
              : ''}{' '}
          </strong>
        ))
      : 'Não informado'}
  </strong>
</li>
*/}

            <li>
              Créditos:{' '}
              {collectionResponse?.personalitiesCredits?.length > 0
                ? collectionResponse?.personalitiesCredits.map(
                    (person, index) => (
                      <strong key={index}>
                        {' '}
                        {person.label || person?.name}{' '}
                        {index <
                        collectionResponse?.personalitiesCredits.length - 1
                          ? '/'
                          : ''}
                      </strong>
                    )
                  )
                : 'Não informado'}
            </li>
            <li>
             País(es) de origem:{' '}
              {collectionResponse?.launchingCountry?.length > 0
                ? collectionResponse?.launchingCountry.map((launchingCountry, index) => (
                    <strong key={index}>
                      {launchingCountry.label || launchingCountry?.name}{' '}
                      {index < collectionResponse?.launchingCountry.length - 1 ? '/' : ''}{' '}
                    </strong>
                  ))
                : 'Não informado'}
            </li>  
            <li>
                Ano de lançamento:
                <strong>
                  {collectionResponse?.launchYear || 'Não informado'}
                </strong>
              </li>
         
            <li>
              Unidade(s):{' '}
              {collectionResponse?.units?.length > 0
                ? collectionResponse?.units.map((unit, index) => (
                    <strong key={index}>
                      {unit.label || unit?.name}{' '}
                      {index < collectionResponse?.units.length - 1 ? '/' : ''}{' '}
                    </strong>
                  ))
                : 'Não informado'}
            </li>
            <li>
              Palavras-chave:{' '}
              {collectionResponse?.keywords?.length > 0
                ? collectionResponse?.keywords.map((word, index) => (
                    <strong key={index}>
                      {word?.value && (
                        <strong>
                          {word.key} - {word.value.toString()}{' '}
                          {index < collectionResponse?.keywords.length - 1
                            ? '/ '
                            : ''}
                        </strong>
                      )}
                    </strong>
                  ))
                : 'Não informado'}
            </li>
            <li>
              Thumbnail:{' '}
              <strong>
                {collectionResponse?.thumbnails?.length > 0
                  ? 'Sim'
                  : 'Não informado'}
              </strong>
            </li>
            {integraDescription.length <= maxLengthSeeMore && (
              <li>
                Descrição da Integra:{' '}
                <strong>
                  {integraDescription || 'Não informado'}
                </strong>
              </li>
            )}
            {integraDescription.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div
                  className={isIntegraDescription ? 'no-ellipsis' : 'ellipsis'}>
                  Descrição da Integra: &nbsp;
                  <strong>{integraDescription}</strong>
                </div>
                <Button
                  onClick={() => showAllText('integraDescription')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isIntegraDescription ? 'Ver Menos' : 'Ver Mais'}
                  {isIntegraDescription ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
            {collectionResponse?.shortDescription?.length <=
              maxLengthSeeMore && (
              <li>
                Descrição curta:
                <strong>
                  {collectionResponse?.shortDescription || 'Não informado'}
                </strong>
              </li>
            )}
            {collectionResponse?.shortDescription?.length >
              maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div
                  className={isIntegraDescription ? 'no-ellipsis' : 'ellipsis'}>
                  Descrição curta: &nbsp;
                  <strong>
                    {collectionResponse?.shortDescription || 'Não informado'}
                  </strong>
                </div>
                <Button
                  onClick={() => showAllText('shortDescription')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isShortDescription ? 'Ver Menos' : 'Ver Mais'}
                  {isShortDescription ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
            {collectionResponse?.fullDescription?.length <=
              maxLengthSeeMore && (
              <li>
                Descrição longa:
                <strong>
                  {collectionResponse?.fullDescription || 'Não informado'}
                </strong>
              </li>
            )}
            {collectionResponse?.fullDescription?.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div className={isFullDescription ? 'no-ellipsis' : 'ellipsis'}>
                  Descrição longa: &nbsp;
                  <strong>
                    {collectionResponse?.fullDescription || 'Não informado'}
                  </strong>
                </div>
                <Button
                  onClick={() => showAllText('fullDescription')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isFullDescription ? 'Ver Menos' : 'Ver Mais'}
                  {isFullDescription ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
            {collectionResponse?.comments?.length <= maxLengthSeeMore && (
              <li>
                Observações gerais:{' '}
                <strong>
                  {collectionResponse?.comments || 'Não informado'}
                </strong>
              </li>
            )}
            {collectionResponse?.comments?.length > maxLengthSeeMore && (
              <li style={{ position: 'relative' }}>
                <div className={isComments ? 'no-ellipsis' : 'ellipsis'}>
                  Observações gerais: &nbsp;
                  <strong>
                    {collectionResponse?.comments || 'Não informado'}
                  </strong>
                </div>
                <Button
                  onClick={() => showAllText('comments')}
                  variant="text"
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    textTransform: 'capitalize',
                  }}>
                  {isComments ? 'Ver Menos' : 'Ver Mais'}
                  {isComments ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </Button>
              </li>
            )}
          </ul>
        </Grid>
        {formValidation != undefined && formValidation.length > 0 && (
          <Grid
            item
            xs={13}
            sx={{ backgroundColor: '#ddedff', margin: 5, borderRadius: 6 }}>
            <Grid item xs={12}>
              <div
                className="video_label-title_validation"
                style={{ marginTop: 10 }}>
                Campos obrigatórios não preenchidos!
              </div>
              <div className="video_label-title_validation_2">
                Por favor, preencha os campos abaixo para que seja possível
                publicar sua coleção:
              </div>
            </Grid>
            <div style={{ marginLeft: 15, marginBottom: 15 }}>
              {formValidation.map((items, index) => {
                console.log(JSON.stringify(formValidation))
                return (
                  <li
                    key={index}
                    style={{ listStyleType: 'none', fontSize: 15 }}>
                    <ReportGmailerrorredIcon
                      fontSize="small"
                      sx={{ color: 'red' }}
                    />{' '}
                    {collecionFormValidation[items]}
                  </li>
                );
              })}
            </div>
          </Grid>
        )}
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  );
}

export default CollectionStep6;
